import styled from "@emotion/styled";

export const XomEverywhereContainer = styled.div`
  width: 100%;
`;

export const XomEverywhereIframe = styled.iframe`
  border: none;
  width: 100%;
  height: min(650px, calc(100vw * 2 - 150px));
`;